import styled from 'styled-components';
import { IS_STAGING } from '../../firebase';

// Billing ledger B1.1. Shows on PR previews only: they are built with
// REACT_APP_FIREBASE_ENV=staging. The production build has no value, so
// IS_STAGING is false there and this renders nothing.
// Fixed to the bottom because the site header is fixed to the top.
const BAR_HEIGHT = '32px';

const Bar = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  min-height: ${BAR_HEIGHT};
  padding: 6px 16px;
  box-sizing: border-box;
  background-color: #fff3cd;
  border-top: 1px solid #e0b94a;
  color: #5c4400;
  font-size: 13px;
  line-height: 1.5;
  text-align: center;
`;

// Keeps the bar from hiding the end of the page.
const Spacer = styled.div`
  height: ${BAR_HEIGHT};
`;

const StagingBanner = () => {
  if (!IS_STAGING) return null;
  return (
    <>
      <Spacer aria-hidden="true" />
      <Bar role="note">
        <strong>Test site: fake data.</strong> Pay with test card 4242 4242 4242 4242.
      </Bar>
    </>
  );
};

export default StagingBanner;
